import React from 'react';
import PropTypes from 'prop-types';

export default function SaleTagFull(props) {
  const {
    onSale,
    salePrice,
    salePercent,
    settings,
    url,
  } = props;

  if (!onSale) {
    return null;
  }

  const tagWidth = 84;
  const tagRight = -10;
  const tagBottom = 24;
  const { saleTagColor } = settings;
  const textColor = '#fff';
  const textSubColor = '#ecf0f5';

  const wrapperStyles = {
    position: 'absolute',
    right: tagWidth + tagRight,
    bottom: tagBottom,
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '18px 15px 15px 0',
    borderColor: `transparent ${saleTagColor} transparent transparent`,
  };

  const saleTagStyles = {
    position: 'absolute',
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    backgroundColor: saleTagColor,
    color: textColor,
    lineHeight: '10px',
    padding: '0px 0 0 2px',
    border: 2,
    right: tagRight,
    bottom: tagBottom,
    width: tagWidth,
    fontSize: '0.9em',
  };

  const linkStyles = {
    color: textColor,
  };

  const saveStyles = {
    fontSize: 12,
    color: textSubColor,
  };

  return (
    <div>
      <div style={wrapperStyles} />
      <div style={saleTagStyles}>
        <a target="_blank" rel="noopener noreferrer" style={linkStyles} href={url}>
          $
          {salePrice}
          <br />
          <span style={saveStyles}>
            Save
            {salePercent}
            %
          </span>
        </a>
      </div>
    </div>
  );
}

SaleTagFull.propTypes = {
  onSale: PropTypes.bool,
  salePrice: PropTypes.string,
  salePercent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  settings: PropTypes.shape({
    saleTagColor: PropTypes.string,
  }),
  url: PropTypes.string,
};
